/**
 * ANB Klaviyo Cart Tracking
 * Tracks "Added to Cart" events globally across all product pages
 */

(function() {
  'use strict';
  
  // Ensure _learnq is initialized
  window._learnq = window._learnq || [];
  
  var klAjax = true;
  var trackingEnabled = false;
  
  // Wait for Klaviyo to be ready
  function waitForKlaviyo() {
    if (window._learnq && typeof window._learnq.push === 'function') {
      trackingEnabled = true;
      console.log('[ANB] Klaviyo tracker ready');
    } else {
      setTimeout(waitForKlaviyo, 100);
    }
  }
  
  // Start waiting for Klaviyo
  waitForKlaviyo();
  
  // Intercept fetch API for cart/add.js
  (function (ns, originalFetch) {
    ns.fetch = function() {
      const response = originalFetch.apply(this, arguments);
      
      response.then(function(res) {
        if (res.url && res.url.includes('/cart/add.js')) {
          if (klAjax && trackingEnabled) {
            klAjax = false;
            console.log('[ANB] Cart add detected, tracking with Klaviyo...');
            
            setTimeout(function() {
              fetch(window.location.origin + '/cart.js')
                .then(function(r) { return r.json(); })
                .then(function(cart) {
                  window._learnq.push(['track', 'Added to Cart', {
                    $value: cart.total_price / 100,
                    total_price: cart.total_price / 100,
                    total_discount: cart.total_discount,
                    original_total_price: cart.original_total_price / 100,
                    items: cart.items
                  }]);
                  console.log('[ANB] Klaviyo tracking sent:', cart);
                  setTimeout(function() { klAjax = true; }, 1000);
                })
                .catch(function(err) {
                  console.error('[ANB] Klaviyo tracking error:', err);
                  klAjax = true;
                });
            }, 300);
          }
        }
      }).catch(function(err) {
        // Silently handle fetch errors
      });
      
      return response;
    };
  }(window, window.fetch));
  
})();

